const PurchaseOrder_sample = [
  {
    orderData: {
      pot_id: "pot_id",
      store_id: "store_id",
      cmr_id: "cmr_id",
      cmr_phone_number: "cmr_phone_number",
      pot_total_gst: "pot_total_gst",
      pot_total_discount: "pot_total_discount",
      pot_payment_status: "pot_payment_status",
      pot_transaction_id: "pot_transaction_id",
      pot_order_status: "pot_order_status",
      pot_payment_method: "pot_payment_method",
      pot_billing_address: "pot_billing_address",
      pot_total_amount: "pot_total_amount",
      pot_round_off_value: "pot_round_off_value",
      pot_delivery_date: "pot_delivery_date",
      pot_document_date: "pot_document_date",
      cmr_code: "cmr_code",
      cmr_name: "cmr_name",
      inv_no: "inv_no",
      customer_invoice_number: "customer_invoice_number",
      created_date: "created_date",
      update_date: "update_date",
      pot_sub_total: "pot_sub_total",
      pot_ship_to_address: "pot_ship_to_address",
      pot_pay_to_address: "pot_pay_to_address"
    },
    itemData: [
      {
        item_id: "item_id",
        item_code: "item_code",
        item_generic_name: "item_generic_name",
        item_name: "item_name",
        item_pack_size: "item_pack_size",
        item_rack_location: "item_rack_location",
        item_unit_price: "item_unit_price",
        item_quantity: "item_quantity",
        item_schedule: "item_schedule",
        item_to_be_received: "item_to_be_received",
        item_invoice_open_quantity: "item_invoice_open_quantity",
        item_discount_amount: "item_discount_amount",
        item_discount_percentage: "item_discount_percentage",
        item_tax_amount: "item_tax_amount",
        item_total_tax_percentage: "item_total_tax_percentage",
        item_total_amount: "item_total_amount",
        item_uom: "item_uom",
        item_uom_id: "item_uom_id",
        item_gst: "item_gst",
        item_sgst: "item_sgst",
        item_cgst: "item_cgst",
        item_igst: "item_igst",
        item_maximum_purchasing: "item_maximum_purchasing",
        item_minimun_purchasing: "item_minimun_purchasing",
        item_return_availability: "item_return_availability",
        item_hsn: "item_hsn",
        item_manufacturer_id: "item_manufacturer_id",
        item_manufacturer_name: "item_manufacturer_name",
        molecule_name: "molecule_name",
        mrp: "mrp",
        item_batch_total_base_purchase_rate: "item_batch_total_base_purchase_rate",
        item_purchase_return: "item_purchase_return",
        total_sellable_quantity: "total_sellable_quantity"
      }
    ]
  }
];
const storeDetailsResult_sample = [
  {
    company: "COMAPNY_NAME",
    company_address: "COMPANY_LOCATION",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_XX_XX",
    dl_no_21_21b: "DRUG_LICENSE_XX_XX",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default {PurchaseOrder_sample,storeDetailsResult_sample};